import React from 'react';

interface MonolithVesselProps {
  children: React.ReactNode;
  nodeCode?: string;
  isModal?: boolean;
  onCloseModal?: () => void;
}

export const MonolithVessel: React.FC<MonolithVesselProps> = ({
  children,
  nodeCode = 'HERX // MESH GATE',
  isModal = false,
  onCloseModal,
}) => {
  return (
    <div
      className="monolith-container"
      data-testid="secret-key-registration-gateway"
      style={
        isModal
          ? {
              minHeight: 'auto',
              backgroundColor: 'transparent',
              padding: 0,
            }
          : undefined
      }
    >
      <div className="monolith-card">
        {isModal && onCloseModal && (
          <button
            type="button"
            onClick={onCloseModal}
            aria-label="Close"
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'transparent',
              border: 'none',
              color: 'var(--mono-text-muted)',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            ✕
          </button>
        )}
        {/* Subtle top edge datum line */}
        <div className="monolith-datum-bar">
          <span className="datum-dot" />
          <span className="datum-text">{nodeCode}</span>
        </div>

        <div className="monolith-body">{children}</div>
      </div>
    </div>
  );
};
